import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import Iconfont from '@base/lib/Iconfont';
import { SharePopupPC } from '@base/lib/share/SharePopupPC';
import { IProductShareTasks, IVariant } from 'base/interfaces/product';
import ShareSuccessPopup from '@base/product/ShareSuccessPopup';
import { shareProductFinish } from '@base/product/services';
import { SharePopupM } from '@base/lib/share/SharePopupM';

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

type IProps = {
    shownVariant: IVariant;
    className?: string;
}

const ProdShare: React.FC<IProps> = (props) => {

    const { shownVariant, className } = props;

    const [shareData, setShareData] = useState<IProductShareTasks>()
    const [successPopupOpen, setSuccessPopupOpen] = useState<boolean>(false)

    const onCloseSuccessPopup = () => {
        setSuccessPopupOpen(false)
    }

    const onClickShareItem = async () => {
        try {
            const res = await shareProductFinish({
                variantId: shownVariant.variantId
            })
            if (res.success || !!res.points) {
                setShareData(res)
                setSuccessPopupOpen(true)
            }

        } catch (e) {

        }
    }

    return (
        <>
            <ShareSuccessPopup
                shareData={shareData}
                open={successPopupOpen}
                onClosePopup={onCloseSuccessPopup}
            />
            {isPhone ? (
                <SharePopupM
                    url={shownVariant.url}
                    title={shownVariant.productName}
                    media={shownVariant.pics[0]?.picLink}
                    showThumb
                    utmQuery={{ utm_term: shownVariant.variantId }}
                    trackTargetPrefix={shownVariant.variantId}
                    onClickItem={onClickShareItem}
                >
                    {({ open }) => (
                        <Button
                            type="text"
                            className={className}
                            onClick={open}
                        >
                            <Iconfont className="icon-minimized"/>
                        </Button>
                    )}
                </SharePopupM>
            ) : (
                <SharePopupPC
                    url={shownVariant.url}
                    utmQuery={{ utm_term: shownVariant.variantId }}
                    trackTargetPrefix={shownVariant.variantId}
                    onClickItem={onClickShareItem}
                >
                    <Iconfont className={'g-prod-share icon-minimized'}/>
                </SharePopupPC>
            )
            }
        </>
    );
};

export default ProdShare